import { Grid, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'
import EmptyStateWrapper from '../../../ui/components/EmptyState/PaperWrapper'

const NoResults = () => {
  const t = useTranslations()

  return (
    <Grid
      container
      spacing={4}
      sx={{
        marginTop: 0,
      }}
    >
      <Grid item xs>
        <EmptyStateWrapper>
          <Typography variant="h1">{t('empty:no-invoices')}</Typography>
        </EmptyStateWrapper>
      </Grid>
    </Grid>
  )
}

export default NoResults
